







import Vue               from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading           from '@/components/Loading.vue'

@Component({
    components: {Loading}
})
export default class CustomButton extends Vue {
    @Prop(Boolean)
    private fluid!: boolean

    @Prop(Boolean)
    private square!: boolean

    @Prop(Boolean)
    private loading!: boolean
}
